<template>
  <div>
    <v-toolbar color="primary">
      Create New Contact
    </v-toolbar>
    <v-card>
      <v-card-subtitle class="">
        {{ selectedCustomer.PARTYMST_DESC }}
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="loginForm">
          <v-row>
            <v-col cols="12">
              <v-select
                :items="contactTypes"
                v-model="contactType"
                item-value="CNT_DOCNO"
                item-text="CNT_DESC"
                label="Contact type"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field dense v-model="contname" label="Name" required />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field dense v-model="contemail" label="E-mail" required />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                dense
                v-model="contdesg"
                label="Designation"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                dense
                v-model="contmob"
                label="Mob"
                required
                type="number"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                dense
                outlined
                v-model="contloc.lat"
                label="Lat"
                required
                type="number"
                :placeholder="'' + myLocation.latitude"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                dense
                outlined
                v-model="contloc.lon"
                label="Lon"
                required
                type="number"
                :placeholder="'' + myLocation.longitude"
                depressed="true"
                flat
              />
            </v-col>
          </v-row>
        </v-form>

        *Contact verification by <b>Credit Control</b> dept.
      </v-card-text>
      <v-card-actions>
        <v-row class="d-flex justify-center">
          <v-btn color="primary" large @click="addContact" :loading="loading">
            <v-icon>
              mdi-floppy
            </v-icon>
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
// import axios from "axios";
import secure_axios from "../services/secure_axios";


export default {
  name: "Newcontact",
  props: [],
  data() {
    return {
      contactType: null,
      contname: "",
      contemail: "",
      contmob: "",
      contdesg: "",
      contloc: { lat: null, lon: null },
    };
  },

  computed: {
    sessionAPI() {
      return this.$store.getters.sessionAPI
    },
    loading() {
      return this.$store.getters.loading;
    },

    selectedCustomer() {
      return this.$store.getters.thiscustomer;
    },
    myLocation() {
      return this.$store.getters.myLocation;
    },
    contactTypes() {
      return this.$store.getters.contacttypes;
    },
    contactLocation() {
      if (this.contloc.lat != null && this.contloc.lon != null) {
        return {
          latitude: this.contloc.lat * 1,
          longitude: this.contloc.lon * 1,
        };
      } else {
        return {
          latitude: this.myLocation.latitude,
          longitude: this.myLocation.longitude,
        };
      }
    },
  },

  methods: {
    addContact() {
      this.$store.dispatch("getLoading", true);
      try {
        const resp = secure_axios.post(this.sessionAPI + "contact", {
          desg: this.contdesg,
          doctype: this.selectedCustomer.PARTYMST_DOCTYPE,
          docno: this.selectedCustomer.PARTYMST_DOCNO,
          email: this.contemail,
          gpslat: this.contactLocation.latitude,
          gpslon: this.contactLocation.longitude,
          mob: this.contmob,
          name: this.contname,
          type: this.contactType,
        });

        console.log(resp);
        
          this.$store.dispatch("getMsgColor", "limegreen");
          this.$store.dispatch("getMsgHeading", "Success!");
          this.$store.dispatch("getMsgText", "New contact added successfully");
          this.$store.dispatch("getShowPop", true);

          this.$emit("NewContOut");
        
      } catch (err) {
        // Handle Error Here
        console.error(err);
        this.$store.dispatch("getError", err);
      }
      this.$store.dispatch("getLoading", false);
    },
  },

  mounted() {
    this.$store.dispatch("getMyLocation");
    this.$store.dispatch("getContactTypes");
  },
};
</script>

<style scoped></style>
